
import { useState } from 'react';
import { Game, Source } from '../../types';
import Header from '../../components/feature/Header';
import GameList from './components/GameList';
import ChatArea from './components/ChatArea';
import SourceModal from './components/SourceModal';
import Toast from '../../components/base/Toast';

export default function HomePage() {
  const [selectedGame, setSelectedGame] = useState<Game | undefined>();
  const [sourceModalOpen, setSourceModalOpen] = useState(false);
  const [selectedSources, setSelectedSources] = useState<Source[]>([]);
  const [toast, setToast] = useState<{ message: string; type: 'success' | 'error' | 'warning' } | null>(null);
  
  const handleGameSelect = (game: Game) => {
    if (selectedGame?.id !== game.id) {
      setSelectedGame(game);
      setToast({
        message: `${game.name}のチャットに切り替えました`,
        type: 'success'
      });
    }
  };
  
  const handleSourceClick = (sources: Source[]) => {
    setSelectedSources(sources);
    setSourceModalOpen(true);
  };
  
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-teal-50" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
      <Header />
      
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 h-[calc(100vh-12rem)]">
          {/* ゲーム一覧 */}
          <div className="lg:overflow-y-auto">
            <div className="mb-6">
              <h2 className="text-2xl font-bold text-gray-900 mb-3">ゲーム一覧</h2>
              <p className="text-gray-600 leading-relaxed">
                遊びたいゲームを選んで、ルールや遊び方をAIに質問できます。<br />
                TRPGからボードゲームまで幅広く対応しています。
              </p>
            </div>
            <GameList
              onGameSelect={handleGameSelect}
              selectedGameId={selectedGame?.id}
            />
          </div>
          
          {/* チャットエリア */}
          <div className="bg-white rounded-2xl shadow-lg border border-gray-100 lg:h-full overflow-hidden">
            <ChatArea
              selectedGame={selectedGame}
              onSourceClick={handleSourceClick}
            />
          </div>
        </div>
      </main>
      
      {/* 出典参照モーダル */}
      <SourceModal
        isOpen={sourceModalOpen}
        onClose={() => setSourceModalOpen(false)}
        sources={selectedSources}
        gameName={selectedGame?.name || ''}
      />
      
      {/* トースト通知 */}
      {toast && (
        <Toast
          message={toast.message}
          type={toast.type}
          isVisible={!!toast}
          onClose={() => setToast(null)}
        />
      )}
    </div>
  );
}
